module.exports = __webpack_public_path__ + "img/view-project-avatar.8f83c9be.svg";